import axiosInstance from "./axios";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { setSnackbar } from "../Redux/snackBarSlice";
const useFetchData = (endpoint) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const fetchData = async (params = {}) => {
    setLoading(true);
    // Only include params if they are not empty
    
    const response = await axiosInstance
      .get(endpoint, {
        params: Object.keys(params).length ? params : undefined,
      })
      .then((response) => {
        setLoading(false);
        return response.data;
      })
      .catch((error) => {
        let errorMsg = "";
        if (error.response?.data?.errorMessage) {
          errorMsg = error.response?.data?.errorMessage;
        } else if (error.response?.data?.error) {
          errorMsg = error.response?.data?.error;
        }
        dispatch(
          setSnackbar({
            open: true,
            message: `Error fetching data from ${endpoint}: ${errorMsg}`,
            error: true,
          })
        );
        setLoading(false);
      });
    return response;
  };
  return { fetchData, loading };
};
export default useFetchData;
